module.exports = "<fuse-main></fuse-main>\n<ejs-richtexteditor></ejs-richtexteditor>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main